/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';
import PersonType from '@linc-technologies/linced-common/enums/person-type';

export default class StudentRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      medications: this.store
        .findAll('medical/medication')
        .then((medications) => {
          return medications.filter((medication) => medication.person_id);
        }),
      learners: this.store.query('person', { type: PersonType.LEARNER }),
    });
  }
}
